import React from 'react';

import { Button } from 'ui-components/components/button';
import { Text } from 'ui-components/components/text';
import { THEME_CONSTANTS } from 'ui-components/services/button-theme-service';

import style from '../../../../components/grid-header/reusable-grid-button.module.less';
import { useModal } from '../../../../hooks/use-modal';
import { BulkHarmonizationModal } from '../../../../products/harmonization/bulk/harmonization-modal';
import { bulkHarmonizationMessages } from '../../../../products/harmonization/bulk/messages';
import { useProductContext } from '../product-context';

export const BulkHarmonizationButton = () => {
  const { selectedProductIds } = useProductContext();
  const { open, close, isOpen } = useModal();
  const isDisabled = selectedProductIds.length === 0 || selectedProductIds.length > 10;

  return (
    <>
      <Button
        className={style['reusable-button']}
        disabled={isDisabled}
        disabledTooltipMessage={<Text value={bulkHarmonizationMessages.bulkeGenerateButtonDisabledTooltip} />}
        onClick={open}
        theme={THEME_CONSTANTS.tertiary}
      >
        <Text value={bulkHarmonizationMessages.generateBulkCodes} />
      </Button>
      {isOpen ? <BulkHarmonizationModal onClose={close} /> : null}
    </>
  );
};
